import { Hubspot } from '/@/integrations/hubspot/hubspot.constants';
import Logger from '/@/modules/core/app/helpers/Logger';
import { BaseExternalResourceService } from '/@/modules/core/app/services/abstracts/BaseExternalResourceService';

export class HubspotService extends BaseExternalResourceService {
  async submitForm(formId, fields) {
    const url = `${Hubspot.FORM_SUBMIT_URL}/${Hubspot.PORTAL_ID}/${formId}`;
    try {
      await this.resource.postData(url, { fields });
    } catch (err) {
      Logger.log(err, Logger.LEVEL_ERROR);
    }
  }
}

export default new HubspotService();
